import { useEffect, useState } from "react";
import { X } from "lucide-react";

interface TableSearchInputProps {
  value: string;
  onDebouncedChange: (value: string) => void;
  debounceMs?: number;
  placeholder?: string;
  className?: string;
}

export function TableSearchInput({
  value,
  onDebouncedChange,
  debounceMs = 1000,
  placeholder = "Search tables, restaurants, guests…",
  className = "relative w-full sm:w-72",
}: TableSearchInputProps) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    if (localValue === value) return;
    const timer = setTimeout(() => {
      onDebouncedChange(localValue);
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [localValue, value, debounceMs, onDebouncedChange]);

  return (
    <div className={className}>
      <input
        type="text"
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        placeholder={placeholder}
        className="input input-sm input-bordered w-full pr-9"
      />
      {localValue && (
        <button
          type="button"
          onClick={() => setLocalValue("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-base-content/50 hover:text-base-content"
          title="Clear search"
          aria-label="Clear search"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
